import React from 'react'
import { styled, s } from '@vega/styled'
import { replace } from '@neo/ramda-extra'
import { useDispatch } from 'react-redux'
import { updateFormProgress, resetForm } from 'modules/application'
import { routes } from 'routes'
import { useHistory } from 'react-router-dom'
import { FormProgress } from 'features/broker/applications/components/FormProgress'
import { Wizard, useWizard } from '@vega/formik-wizard'
import { BottomNavigation } from 'features/broker/applications/components/BottomNavigation'
import { View } from './View'
import * as CONSTANTS from '@neo/constants'

const {
  FORM_PROGRESS: {
    STEP_STATUS: { COMPLETED },
  },
} = CONSTANTS

const Root = styled.div(s('flex-1 flex items-center w-full h-full relative'))
const ProgressContainer = styled.div(s('bg-white h-full'))

const Core = styled.div(s('flex flex-column w-full h-full'))
const Content = styled.div(
  s('flex-1 flex justify-center w-full pt-6', {
    paddingRight: 200,
    overflowY: 'scroll',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      width: 0,
      height: 0,
    },
  })
)
const FormContainer = styled.div(s('flex flex-column pt-1'), {
  width: 652,
  '> :last-child': s('pb-12'),
})
const InfoContainer = styled.div(s('relative', { pointerEvents: 'none' }))
const NavigationContainer = styled.div(s('relative zIndex-2'))

function CreditReportStep({ stepId, applicantId, applicantPathId, loanApplicationId }) {
  const history = useHistory()
  const dispatch = useDispatch()

  const { previous } = useWizard()
  const goToOverview = () =>
    history.push(
      replace(':id', loanApplicationId, routes.client.applications.overview.details)
    )

  const onNext = () => {
    dispatch(
      updateFormProgress({
        step: 'creditReport',
        status: COMPLETED,
        applicantId,
      })
    )
  }

  const saveAndExit = () => {
    dispatch(resetForm())
    goToOverview()
  }

  const goBack = () => previous()

  return (
    <Wizard.Step id={stepId} title="Credit Report">
      <Root>
        <ProgressContainer>
          <FormProgress saveAndExit={saveAndExit} />
        </ProgressContainer>

        <Core>
          <Content>
            <FormContainer>
              <View applicantPathId={applicantPathId} applicantId={applicantId} />
            </FormContainer>

            <InfoContainer />
          </Content>

          <NavigationContainer>
            <BottomNavigation goBack={goBack} canNext={true} onNext={onNext} />
          </NavigationContainer>
        </Core>
      </Root>
    </Wizard.Step>
  )
}

export { CreditReportStep }
